export default __webpack_public_path__ + "locales/it/SalesDepartmentRequestDialog.json?hash=de72565131df4563cd95b4832585dd3e";